import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const USER_PATHWAY_PATH = 'userPathway'
const USER_STATIC_LIST_PATH = 'userStaticList'
const USER_MANAGEMENT_PATH = 'userManagement'
const USER_SUPPORT_TEAM_PATH = 'userSupportTeam'
const USER_SYMPTOM_PATH = 'userSymptom'

//#region User Pathway
export function getListUserPathways(userId, dto, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_PATHWAY_PATH}/getList`,
            filterRequest,
            {
                params: {
                    userId,
                    dto,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function addPatientToPathway(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_PATHWAY_PATH}/addPatientToPathway`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getSymptomsPathwayByUser(userId, id) {
    return axiosInstance
        .get(
            `${BACKEND_ENDPOINT}/${USER_PATHWAY_PATH}/getSymptomsPathwayByUser`,
            {
                params: {userId, id},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//#endregion

//#region User Static List
export function getListUserStaticList(userId, dto, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_STATIC_LIST_PATH}/getList`,
            filterRequest,
            {
                params: {
                    userId,
                    dto,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function addPatientToStaticList(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_STATIC_LIST_PATH}/addPatientToStaticList`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region User Management
export function getListUserManagement(userId, dto, filterRequest) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_MANAGEMENT_PATH}/getList`,
            filterRequest,
            {
                params: {
                    userId,
                    dto,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getPageUserManagements(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_MANAGEMENT_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function deleteUserManagement(userId, id) {
    return axiosInstance
        .delete(`${BACKEND_ENDPOINT}/${USER_MANAGEMENT_PATH}/deleteById`, {
            params: {userId, id},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function addPatientToHCP(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_MANAGEMENT_PATH}/addPatientToHCP`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//#endregion

//#region User Symptom
export function getPageUserSymptoms(
    userId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_SYMPTOM_PATH}/getPage`,
            filterRequest,
            {
                params: {
                    userId,
                    pageNumber,
                    pageRows,
                    sortField,
                    sortOrder,
                },
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
//#endregion

//#region User Support Teams
export function addPatientToSupportTeam(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_MANAGEMENT_PATH}/addPatientToSupportTeam`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//#endregion

//#region User General Practitioner
export function addPatientToGeneralPractitioner(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_MANAGEMENT_PATH}/addPatientToGeneralPractitioner`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

//#endregion
